// EXTERNAL
import {Redirect, Route, Switch, BrowserRouter} from "react-router-dom";

// CSS
import "./App.css";

// PAGES
import LoginPage from "./webpages/LoginPage"
import SignupPage from "./webpages/SignupPage";
import PasswordSetPage from "./webpages/PasswordSetPage";
import PasswordResetPage from "./webpages/PasswordResetPage";

/** 
 * This component renders Aroa User Management and handles its routing.
 * 
 * @returns {ReactElement} A React element that renders Aroa User Management. 
 */
function App() {
  
  return (
    <BrowserRouter>
      <Switch>
        <Route path="/login" render = {() => ( 
          <LoginPage></LoginPage>
        )}/>
        <Route path="/signup" render = {() => ( 
          <SignupPage></SignupPage>
        )}/>
        <Route path="/password-set" render = {() => ( 
          <PasswordSetPage></PasswordSetPage>
        )}/>
        <Route path={["/password-reset", "/password-reset/:uid/:token"]} render = {() => ( 
          <PasswordResetPage></PasswordResetPage>
        )}/>
        <Route path="/" render = {() => (
          <Redirect to="/login"></Redirect>
        )}/>
      </Switch>
    </BrowserRouter>
  );
}

export default App;
